import type { Action, StoreActionApi } from 'react-sweet-state';
import type { State, ThirdPartyEntity } from '../../../../common/types';

type SetThirdPartyStateWithPreselectedEntityIdData = {
	entities: ThirdPartyEntity[] | null;
	preSelectedEntityId: string | null;
};

export type SetThirdPartyStateWithPreselectedEntityIdAction = (
	data: SetThirdPartyStateWithPreselectedEntityIdData,
) => Action<State, void, void>;

export const setThirdPartyStateWithPreselectedEntityId =
	({ entities, preSelectedEntityId }: SetThirdPartyStateWithPreselectedEntityIdData) =>
	({ getState, setState }: StoreActionApi<State>) => {
		const { thirdPartyState } = getState();

		const baseThirdPartyState = { ...thirdPartyState, entities };
		if (preSelectedEntityId === null) {
			setState({ thirdPartyState: baseThirdPartyState });
			return;
		}

		const preSelectedEntity = entities?.find((entity) => entity.id === preSelectedEntityId);
		const selectedEntities = preSelectedEntity ? [preSelectedEntity] : null;
		if (preSelectedEntity) {
			setState({
				thirdPartyState: {
					...baseThirdPartyState,
					selectedEntityId: preSelectedEntityId,
					selectedEntities,
				},
			});
			return;
		}

		// Reset selectedEntityId if not valid
		setState({
			thirdPartyState: {
				...baseThirdPartyState,
				selectedEntityId: null,
				selectedEntities: null,
			},
		});
	};
